import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=dad9dc74&scoped=true&lang=pug&"
import script from "./Gift.vue?vue&type=script&lang=js&"
export * from "./Gift.vue?vue&type=script&lang=js&"
import style0 from "./Gift.scss?vue&type=style&index=0&id=dad9dc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad9dc74",
  null
  
)

export default component.exports